import React from 'react'

export default function FieldGoalType_FormValueEmpty(props:any) {

    const height = props.className?.includes(' h-') ? '' : 'h-36' // default height if not set externally

    const classes = Classes(Classes("ui5-field-form-editable dropdown-form", height, props.className))

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                <div className="ui5-txt-no-accent-default txt-truncate">{props.field.placeholder}</div>
            </div>
            {props.children}
        </React.Fragment>
    )
}